import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-listaclientesv2',
  templateUrl: './listaclientesv2.component.html',
  styleUrls: ['./listaclientesv2.component.scss']
})
export class Listaclientesv2Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
